// lockFunc should return true if successfully lock.
export const bigDownload = async function (downloadUrl, lockFunc, unlockFunc) {
  let localObjectUrl;
  try {
    if (!lockFunc()) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    // Download
    const response = await fetch(downloadUrl, {
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/zip"
      }
    });

    if (!response.ok) throw new Error("Download failed");

    // Processing download to blob
    const blob = await response.blob();
    localObjectUrl = window.URL.createObjectURL(blob);

    // Extract filename from Content-Disposition
    const disposition = response.headers.get("Content-Disposition");
    const filename = getFileNameFromDisposition(disposition) || "attachments.zip";

    const a = document.createElement("a");
    a.href = localObjectUrl;
    a.download = filename; // Rails filename
    document.body.appendChild(a);
    a.click();
    a.remove();

  } catch (e) {
    console.error("Error downloading file from: " + downloadUrl, e);
  } finally {
    if (localObjectUrl) {
      window.URL.revokeObjectURL(localObjectUrl);
    }

    unlockFunc();
  }
}

function getFileNameFromDisposition(disposition) {
  if (!disposition) return undefined;
  const match = disposition.match(/filename="?([^"]+)"?/);
  return match ? match[1] : undefined;
}
